module.exports = __webpack_public_path__ + "static/media/password.7bb91fba.svg";